import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { CARD, KICKER } from '../Home/HomeDashboard/dashboardStyles';
import { REDESIGN_COLORS, REDESIGN_FONTS } from '../../constants';
import { fmtNumber } from './adminFormat';

const useStyles = makeStyles(() => ({
    tile: {
        ...CARD,
        padding: '16px 18px',
        minWidth: 0,
    },
    kicker: {
        ...KICKER,
        fontSize: '0.66rem',
    },
    value: {
        margin: '6px 0 2px',
        fontSize: '1.5rem',
        lineHeight: 1.15,
        letterSpacing: '-0.02em',
        fontWeight: REDESIGN_FONTS.weightHeading,
        color: REDESIGN_COLORS.dark,
        overflowWrap: 'anywhere',
    },
    accent: {
        color: REDESIGN_COLORS.accent,
    },
    hint: {
        margin: 0,
        color: REDESIGN_COLORS.muted,
        fontSize: '0.8rem',
        lineHeight: 1.4,
    },
}));

/**
 * One number with a label above and an optional hint below. `value` can be a
 * number (formatted with thousands separators) or a preformatted string.
 */
const StatTile = ({ label, value, hint, accent = false }) => {
    const classes = useStyles();
    const shown = typeof value === 'number' ? fmtNumber(value) : value;
    return (
        <div className={classes.tile}>
            <span className={classes.kicker}>{label}</span>
            <p className={`${classes.value} ${accent ? classes.accent : ''}`}>{shown}</p>
            {hint ? <p className={classes.hint}>{hint}</p> : null}
        </div>
    );
};

export default StatTile;
